import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useAddMergeItem, useSearchFile } from "../../hooks/useCrm";
import Button from "../Button/Button";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import Typography from "../Typography/Typography";
const initValue = {
  IdSalesOpportunities: null,
  IdSalesOpportunities_mergeFile: null,
};
function AddMergeItem({ id, status, setStatus }) {
  const [form, setForm] = useState(initValue);
  const [search, setSearch] = useState("");
  const { mutateAsync: addMergeItem } = useAddMergeItem();
  const {
    data: searcheddata,
    isLoading,
    refetch,
  } = useSearchFile({ Search: search });
  const Users = searcheddata?.data?.users;

  const usersOptions = Users?.map((user) => {
    return {
      value: user.IdS0alesOpportunities,
      label: user.FirstName + " " + user.LastName + " " + user.Phone,
    };
  });
  useEffect(() => {
    setForm({ ...form, IdSalesOpportunities: id });
  }, [id]);
  const handleClick = async (data) => {
    await addMergeItem(data);
  };
  return (
    <div>
      <SimpleSelect1
        placeholder="جستجو در پرونده ها "
        label="انتخاب پرونده"
        res={usersOptions}
        onChange={(e) => {
          setForm({ ...form, IdSalesOpportunities_mergeFile: e.value });
        }}
        onMenuOpen={refetch}
        loadingMessage={() => "در حال بارگزاری"}
        isLoading={isLoading ? true : false}
      />
      <div className="row mt-4">
        <div className="col-6">
          <Button
            bgColor="#009EF7"
            color="#fff"
            onclick={() => {
              handleClick(form);
              setStatus(!status);
            }}
          >
            انتخاب
          </Button>
        </div>
        <div className="col-6">
          <Button
            bgColor="#F1416C"
            color="#fff"
            onclick={() => setStatus(!status)}
          >
            لغو
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddMergeItem;
